import { TFormalOffers } from './formalOffers.types';

export const getTimeOutDate = (formalOffers: TFormalOffers): string => {
    //Currently we assume all timeout dates are the same
    const formalOffer = formalOffers[0];

    const formalOfferTimeOut = formalOffer.timeout!;

    return new Date(formalOfferTimeOut).toISOString();
};
